// extracted by mini-css-extract-plugin
module.exports = {"container":"td","hero":"ud","content":"vd","typeProd":"wd","notTransparent":"xd","sliderDots":"yd","active":"zd"};